/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Shop_Ocop_Stars_NInputs */

const vi_shop_ocop_stars_n = /** @type {(inputs: Shop_Ocop_Stars_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} sao`)
};

/**

* @param {Shop_Ocop_Stars_NInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_ocop_stars_n = /** @type {((inputs: Shop_Ocop_Stars_NInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Ocop_Stars_NInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_ocop_stars_n(inputs)
});